import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { PublicCustomer } from '../models/public-customer.model';

@Injectable({
    providedIn: 'root',
})
export class CustomerService {
    constructor(private httpClient: HttpClient) {}

    getCustomer(): Observable<PublicCustomer> {
        return this.httpClient.get<PublicCustomer>(environment.apiMasterUrl + 'customer/');
    }
}
